import { DynamicContentToolbarNode } from "./dynamic-content-toolbar-node";

import type { LexicalNode } from "lexical";

export function $isDynamicContentToolbarNode(
  node: LexicalNode | null | undefined,
): node is DynamicContentToolbarNode {
  return node instanceof DynamicContentToolbarNode;
}
